<template>
	<div id="enterprise_detail">
		<leftnav class="fl"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
		<div class="index_left_centerpage">
		<div class="enterprise_detail">
			<div class="whitebox centerpage"> 
				<div class="d_blocktitle">
					<i class="title-icon title-icon1"></i>
					<h3 class="ctitle">{{companyinfor.enterpriseName}}</h3> 
				</div>
				<ul class="oh conpany-infor-new">
					<li class="inforLine inforLine-3"><span class="label">统一社会信用代码：</span><span class="infortext">{{companyinfor.unifiedSocialCreditCode}}</span> </li>
					<li class="inforLine inforLine-3"><span class="label">组织机构代码：</span><span class="infortext">{{companyinfor.organizationCode}}</span> </li>
                    <li class="inforLine inforLine-3"><span class="label">行业：</span><span class="infortext">{{companyinfor.industry}}</span> </li>
					<li class="inforLine inforLine-3"><span class="label">企业类型：</span><span class="infortext">{{companyinfor.enterpriseType}}</span> </li>
					<li class="inforLine inforLine-3"><span class="label">注册资本：</span><span class="infortext">{{companyinfor.registeredCapital + companyinfor.currency}}</span> </li>
					<li class="inforLine inforLine-3"><span class="label">成立日期：</span><span class="infortext">{{companyinfor.establishmentDate}}</span> </li>
                    
					<!-- <li class="inforLine inforLine-3"><span class="label">地址：</span><span class="infortext">{{companyinfor.employee}}</span> </li> -->
					<li class="inforLine inforLine-one"><span class="label">经营范围：</span><span class="infortext">{{companyinfor.businessScope || '-'}}</span> </li>
				</ul> 
			</div>
			<div class="whitebox company-contact" > 
					<div class=" d_blocktitle d-floortitle">
						<i class="title-icon title-icon2"></i>
						<h3 class="title">联系方式</h3>
					</div>
					<ul class="oh conpany-infor-new">
						<li class="inforLine inforLine-3"><span class="label">法定代表人：</span><span class="infortext">{{companyinfor.legalRepresentative}}</span> </li>
						<li class="inforLine inforLine-3"><span class="label">联系电话：</span><span class="infortext">{{companyinfor.contactPhone}}</span> </li>
						 <li class="inforLine inforLine-3"><span class="label">邮箱：</span><span class="infortext">{{companyinfor.email}}</span> </li>
						<li class="inforLine inforLine-one"><span class="label">地址：</span><span class="infortext">{{companyinfor.address}}</span> </li> 
					</ul> 
					<div class="enprise_websitebox" v-show="rwebsite" @click="rwebsite=false">
						<div class="enprise_website">
							<h2>您即将跳转进入第三方网站</h2>
							<p class="website_tips"><b>产业大脑</b>不对该网站内容及真实性负责，请注意您的账户和财产安全</p>
							<p class="website_text"><a :href="enterpriseWebsite"  target="_blank">{{enterpriseWebsite}}</a></p>
							<a class="router_website" :href="enterpriseWebsite" target="_blank">继续前往</a>
						</div>
					</div>  
			</div>
		</div>
		</div>
		</div>
	</div>
</template>

<script>
	import { mapState, mapMutations, mapGetters } from "vuex";
	export default {
		name: 'institutionDetail',
		computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
		data() {
			return {
				curindex: 5,
				searchtype:6,enterpriseWebsite:"",
				guidepage:'广东企业',echartWidth2:document.body.offsetWidth*0.8728*0.95*0.48,
				userdata:{},othertransList:[],conditionBar1Data:{value:[0,0,0,0],noEmpty1:false},conditionBar2Data:{value:[0,0,0,0],noEmpty1:false,},
				enterpriseid: 0,profitData:{date:[],list:[],unit:""},debtData:{date:[],list:[],unit:""},cashData:{date:[],list:[],unit:""},
				companyinfor: {title:"",industry:"",block:"", certificatetype:'','insurePerson':0,summary:"",adress:"",phone:"",website:"",portno:""}, 
				floorlist: ['联系方式', '投资领域','投资事件'], 
				rwebsite:false,barHeight:60,
			}
		},  
		beforeCreate() {
				
		},
		created() {
			this.$nextTick(() => {
					// 禁用右键
					document.oncontextmenu = new Function("event.returnValue=false");
					// 禁用选择
					document.onselectstart = new Function("event.returnValue=false");
			}); 
			// window.scrollTo(0,0);
			this.bus.$emit('loading',true);
			this.enterpriseid = this.$route.query.id; 
			var _this=this;
			this.userdata = this.getuseriformation();
			
		},
		mounted() {
			window.scrollTo(0, 0);  
			this.getDetails();
			
		},
		methods: { 
            getDetails(){
                var _this=this;
                let ajaxurl = this.$api.crm.gdEnterprise.detail()+'?id='+this.enterpriseid;
                this.$axios.get(ajaxurl, {
                    headers: {
                        AuthToken: this.userdata.token
                    },
                }).then((res) => {
                    if (res.data.success) {
                        this.companyinfor = res.data.data;
						document.title = this.companyinfor.enterpriseName;

                    }
                })
            },
		//判断企业网址是否符合标准 长度大于4并且要有http
		getEnterpriseWebsite(str){
			// console.log('str',str)
			if(str.length>3){
				if(str.indexOf('http')<0){
					str='http://'+str;
				}  
			}
			this.enterpriseWebsite=str; 
		}, 
			//添加删除收藏
			collectFun(){
				// console.log(this.companyinfor.collectId,this.companyinfor);
				this.listToggleCollect(this.companyinfor,'org') ;
			},
 
			//企业网址跳转
			geturl(url) {  
				if(url.indexOf('http')<0){
					url='http://'+url;
				}
				window.open(url);
				},
		}
	}
</script>

<style scoped>
.conpany-infor-new .infortext {
    float: left;
    width: calc(100% - 160px);
}
.conpany-infor-new .label {
    color: #999;
    margin-right: 4px;
    width: 151px;
    float: left;
}
	.enterprise_table{
		margin-bottom: 50px;
	}
	.endsm_title{
		border-left:8px solid #3e7bfa;line-height: 20px; padding-left:14px;margin: 10px 0 30px;
	}
</style> 
